<div role="main">
	<div class="container page-contents">
		<div class="row justify-content-center">
			<div class="col-12 px-2 px-md-4" *ngIf="authService.accountUser">
				<h2 class="row pt-3">
					<div class="col">
						<span i18n="my account page/menu title">My account</span>
					</div>
					<div class="col-xs-auto">
						<button type="button" class="btn btn-outline-dark btn-sm refresh-btn" (click)="refreshAccounts()">
							<span class="material-icons">cached</span>
						</button>
					</div>
				</h2>
				<hr class="mt-0"/>
				<div class="row px-3">
					<mat-card class="col-12 col-md-6" *ngIf="userProfileFormData">
						<app-form-editor [formdata]="userProfileFormData"></app-form-editor>
					</mat-card>
				</div>
			</div>
		</div>
	</div>
</div>
